import './input.scss';

import classnames from 'classnames';
import { arrayOf, bool, func, number } from 'prop-types';
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { InputGroupAddon, InputGroupText } from 'reactstrap';

import getDisplayName from '../../../utils/get-display-name';

function CharacterLimitAddon({
  focused,
  length,
  isLimitExceeded,
  actualLength,
}) {
  const showLengthIndicator = length > 0 && (isLimitExceeded || focused);

  return (
    <CSSTransition
      in={showLengthIndicator}
      timeout={250}
      classNames="c-input__character-limit-"
    >
      <InputGroupAddon addonType="append" className="c-input__character-limit">
        <InputGroupText
          className={classnames({ 'text-danger': isLimitExceeded })}
        >
          {length - actualLength}
        </InputGroupText>
      </InputGroupAddon>
    </CSSTransition>
  );
}

CharacterLimitAddon.propTypes = {
  focused: bool.isRequired,
  isLimitExceeded: bool,
  length: number,
  actualLength: number,
};

CharacterLimitAddon.defaultProps = {
  length: 0,
  isLimitExceeded: false,
  actualLength: 0,
};

function withCharacterLimit(WrappedComponent) {
  function WithCharacterLimit({ addons, ...rest }) {
    return (
      <WrappedComponent addons={[...addons, CharacterLimitAddon]} {...rest} />
    );
  }

  WithCharacterLimit.propTypes = {
    addons: arrayOf(func.isRequired),
  };

  WithCharacterLimit.defaultProps = {
    addons: [],
  };

  WithCharacterLimit.displayName = `withCharacterLimit(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithCharacterLimit;
}

export default withCharacterLimit;
